/* Satori PDP — gallery, buy-box, quantity, cursor, reveals */
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var root = document.querySelector('.satori-pdp');
  if(!root) return;

  function cursor(){
    if(!fine || reduce) return;
    var cur=document.querySelector('.satori-cursor'), ring=document.querySelector('.satori-cursor-ring');
    if(!cur||!ring) return;
    var mx=innerWidth/2,my=innerHeight/2,rx=mx,ry=my;
    document.addEventListener('mousemove',function(e){mx=e.clientX;my=e.clientY;cur.style.left=mx+'px';cur.style.top=my+'px';});
    (function loop(){rx+=(mx-rx)*0.18;ry+=(my-ry)*0.18;ring.style.left=rx+'px';ring.style.top=ry+'px';requestAnimationFrame(loop);})();
    root.querySelectorAll('a,button,.satori-opt,.satori-thumb,summary,select,.satori-mag').forEach(function(el){
      el.addEventListener('mouseenter',function(){root.classList.add('hovering');});
      el.addEventListener('mouseleave',function(){root.classList.remove('hovering');});
    });
    root.querySelectorAll('.satori-mag').forEach(function(el){
      el.addEventListener('mousemove',function(e){var r=el.getBoundingClientRect();el.style.transform='translate('+(e.clientX-(r.left+r.width/2))*0.18+'px,'+(e.clientY-(r.top+r.height/2))*0.28+'px)';});
      el.addEventListener('mouseleave',function(){el.style.transform='';});
    });
  }

  function reveals(){
    if(window.gsap && window.ScrollTrigger && !reduce){
      gsap.registerPlugin(ScrollTrigger);
      gsap.utils.toArray('.satori-reveal').forEach(function(el){
        gsap.to(el,{opacity:1,y:0,duration:1,ease:'power3.out',scrollTrigger:{trigger:el,start:'top 92%'}});
      });
    } else {
      document.querySelectorAll('.satori-reveal').forEach(function(e){e.style.opacity=1;e.style.transform='none';});
    }
  }

  function gallery(){
    var main=document.getElementById('satori-gmain-img');
    if(!main) return;
    document.querySelectorAll('.satori-thumb').forEach(function(t){
      t.addEventListener('click',function(e){
        e.preventDefault();
        document.querySelectorAll('.satori-thumb').forEach(function(x){x.classList.remove('active');});
        t.classList.add('active');
        main.style.opacity=0;
        setTimeout(function(){main.src=t.getAttribute('data-src');main.style.opacity=1;},170);
      });
    });
  }

  function buybox(){
    var planInput=document.getElementById('satori-selling-plan');
    var addLabel=document.getElementById('satori-add-label');
    var cadence=document.querySelector('.satori-cadence');
    var qtyInput=document.getElementById('satori-qty');
    function update(){
      var sel=document.querySelector('.satori-opt.sel');
      if(!sel) return;
      var plan=sel.getAttribute('data-plan')||'';
      if(planInput) planInput.value=plan;
      if(addLabel && sel.getAttribute('data-add')) addLabel.textContent=sel.getAttribute('data-add');
      if(cadence) cadence.classList.toggle('show', plan!=='');
    }
    document.querySelectorAll('.satori-opt').forEach(function(o){
      o.addEventListener('click',function(){
        document.querySelectorAll('.satori-opt').forEach(function(x){x.classList.remove('sel');x.setAttribute('aria-pressed','false');});
        o.classList.add('sel'); o.setAttribute('aria-pressed','true'); update();
      });
    });
    document.querySelectorAll('[data-q]').forEach(function(b){
      b.addEventListener('click',function(e){e.preventDefault();var v=Math.max(1,(parseInt(qtyInput.value,10)||1)+parseInt(b.getAttribute('data-q'),10));qtyInput.value=v;});
    });
    update();
  }

  function init(){ cursor(); reveals(); gallery(); buybox(); }
  if(document.readyState!=='loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* tasting bars fill on view */
(function(){
  var bars=document.querySelectorAll('.satori-bar .fill'); if(!bars.length) return;
  function fill(){bars.forEach(function(f){f.style.width=f.getAttribute('data-w')+'%';});}
  var taste=document.querySelector('.satori-taste');
  if('IntersectionObserver' in window && taste){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){fill();io.disconnect();}});},{threshold:.25});
    io.observe(taste);
  } else fill();
})();
